import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouseCircleCheck } from '@fortawesome/free-solid-svg-icons'

export const OptionLabel = ({
  given_name, 
  family_name, 
  address_line1, 
  locality, 
  administrative_area, 
  postal_code 
}) => {
  return (
    <label>
      <span className="name">
        <FontAwesomeIcon icon={faHouseCircleCheck} />
        {given_name} {family_name}
      </span>
      <span>{address_line1}</span>
      <span>{locality}, {administrative_area}, {postal_code}</span>
      <span className="estimate">1-5 days estimated dispatch</span>
    </label>
  )
}

export const formatOptions = (values) => {
  return values.map(value => {
    const { address, drupal_internal__profile_id } = value

    return {
      label: OptionLabel(address),
      value: drupal_internal__profile_id,
      address: address
    }
  })
}